module.exports = __webpack_public_path__ + "static/media/zero-logo.a3bd23bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zero-logo.svg
// module id = 650
// module chunks = 0